import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ModalService } from "./modal.service";
import { IsLoadingService } from "./is-loading.service";
import { URL_HELP_API } from "environments/environment";
import { Documento } from "app/models/upload-documento/documento";
import { Observable } from "rxjs";
import { parseErrorBlob } from "app/shared/helpers/format/http-util";
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class DocumentoService extends BaseService<Documento> {
    constructor(
        protected httpClient: HttpClient,
        protected modalService: ModalService,
        protected isLoadingService: IsLoadingService
    ) { super(httpClient, modalService, isLoadingService); }

    public obterDocumentos(cpf: string): Promise<Documento[]> {
        return new Promise<Documento[]>((resolve, reject) => {
            this.httpClient.get<Documento[]>(`${URL_HELP_API.UPLOAD.LISTAR}/${cpf}`)
                .subscribe((res: Documento[]) => {
                    resolve(res);
                }, ((err: any) => {
                    this.error(err);
                    reject(err);
                })
                );
        });
    }

    public removeItem(id: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.httpClient.delete(`${URL_HELP_API.UPLOAD.EXCLUSAO}/${id}`).subscribe(
                (response: any) => {
                    resolve(response);
                },
                (err: HttpErrorResponse) => {
                    this.error(err);
                    reject(false);
                }
            );
        });
    }

    downloadDocumento(idArquivo: number): Observable<any> {
        return this.httpClient.get(`${URL_HELP_API.UPLOAD.DOWNLOAD}/${idArquivo}`, {responseType: 'blob'}).pipe(
            catchError(parseErrorBlob)
        )
    }

    upload(file: FormData, cpf: string): Observable<any> {
        return this.httpClient.post<any>(`${URL_HELP_API.UPLOAD.UPLOAD}/${cpf}`, file);
    }
}